export type UserStorageKey =
    "AuthToken" |
    "MicrosoftTeamsContext" |
    "MicrosoftTeamsUserJoinedTeamsInfo" |
    "MostRecentTeamId" |
    "InstallId" |
    "ShareWithTeamAssignedShifts" |
    "ShareWithTeamOpenShifts" |
    "ShareWithTeamPreference" |
    "ScheduleGrouped" |
    "ShowStaffPer30Rows" |
    "TelemetryRegion" |
    "ExportTimeClockReportOption" |
    "BlankScheduleFirstSeenTime";
/**
 * These enums are used as keys for the UserStorageService
 */
export enum UserStorageKeys {
    AuthToken = "AuthToken",
    MicrosoftTeamsContext = "MicrosoftTeamsContext",
    MicrosoftTeamsUserJoinedTeamsInfo = "MicrosoftTeamsUserJoinedTeamsInfo",
    MostRecentTeamId = "MostRecentTeamId",
    InstallId = "InstallId",
    ShareWithTeamAssignedShifts = "ShareWithTeamAssignedShifts",
    ShareWithTeamOpenShifts = "ShareWithTeamOpenShifts",
    ScheduleGrouped = "ScheduleGrouped",
    ShowStaffPer30Rows = "ShowStaffPer30Rows",

    /**
     * The telemetry region
     */
    TelemetryRegion = "TelemetryRegion",
    /**
     * Store the option selected for exporting time clock report. Legacy report or new report
     */
    ExportTimeClockReportOption = "ExportTimeClockReportOption",

    /**
     * Stores { weekStart, firstSeenTime } for when an FLM first views a blank schedule in a given week.
     * Used to compute time-from-blank-schedule-to-first-publish telemetry.
     */
    BlankScheduleFirstSeenTime = "BlankScheduleFirstSeenTime"
}